import BaseModal from "./BaseModal";
import Icon1 from "@assets/icons/Icon";
import { QRCodeSVG } from "qrcode.react";
import { IOS_URL, ANDROID_URL } from "@constants/mobileApp";

interface MobileAppModalProps {
  onClose: () => void;
}

export function MobileAppModal({ onClose }: MobileAppModalProps) {
  return (
    <BaseModal
      onClose={onClose}
      title="Application mobile"
      startIcon={<Icon1 name="smartphone" size={20} />}
      width="max-w-lg"
    >
      <div className="p-6 flex flex-col gap-6">
        <p className="text-center text-neutral-600 text-h3">
          Scannez le QR code correspondant à votre appareil pour télécharger
          l'application.
        </p>

        {/* iOS */}
        <div className="flex flex-row items-center gap-4 p-4 rounded-xl border border-neutral-200 bg-neutral-50">
          <div className="bg-white p-2 rounded-lg border border-neutral-200 shadow-sm flex-shrink-0">
            <QRCodeSVG value={IOS_URL} size={120} level="M" />
          </div>
          <div className="flex flex-col gap-1">
            <span className="text-h2 font-semibold text-neutral-800">
              App Store
            </span>
            <span className="text-h4 text-neutral-500">iPhone / iPad</span>
          </div>
        </div>

        {/* Android */}
        <div className="flex flex-row items-center gap-4 p-4 rounded-xl border border-neutral-200 bg-neutral-50">
          <div className="bg-white p-2 rounded-lg border border-neutral-200 shadow-sm flex-shrink-0">
            <QRCodeSVG value={ANDROID_URL} size={120} level="M" />
          </div>
          <div className="flex flex-col gap-1">
            <span className="text-h2 font-semibold text-neutral-800">
              Google Play
            </span>
            <span className="text-h4 text-neutral-500">Android</span>
          </div>
        </div>
      </div>
    </BaseModal>
  );
}
